import { Text } from '@components/text';

import { useFileTranslations } from './locale';

export type FileAcceptTextProps = {
  accept?: string;
  maxFileSizeMb?: number;
};

export const FileAcceptText = ({ accept, maxFileSizeMb }: FileAcceptTextProps) => {
  const { t } = useFileTranslations();
  const parts = [
    maxFileSizeMb === undefined ? undefined : t('maxFileSize', { size: maxFileSizeMb }),
    accept ? `${t('accepted')} ${accept}` : undefined,
  ].filter((part): part is string => Boolean(part));

  if (parts.length === 0) return null;

  return <Text font="regular14" color="purple60" text={parts.join(' • ')} />;
};
